import { GenIcon } from '../helpers/IconBase.es.js';

const SpacerOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 32 32", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M16.0251 16L16.0251 24",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12.7556 20.7272L16.0283 23.9999L19.301 20.7272",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.0317 16L16.0317 8",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M19.3011 11.2728L16.0283 8.0001L12.7556 11.2728",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M26 4L6 4",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M26 28L6 28",
          stroke: "#DBDBDB",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { SpacerOutlined };
